var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCt2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 4,
    fill: "#E3F9F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_7098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8184 17H19.9978C19.1453 17 18.7185 18.0307 19.3212 18.6334L48.3678 47.68C48.9706 48.2828 50.0012 47.8559 50.0012 47.0035V18.1828C50.0012 17.5296 49.4717 17 48.8184 17V17ZM43.6547 35.154C43.6547 35.4895 43.2492 35.6575 43.0119 35.4203L31.581 23.9893C31.3437 23.7521 31.5118 23.3465 31.8472 23.3465H43.1892C43.4463 23.3465 43.6547 23.5549 43.6547 23.812V35.154Z",
    fill: "url(#paint0_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8208 21.0273H24.0671C23.7088 21.0273 23.5293 21.4606 23.7827 21.714L49.7375 47.6688C49.8996 47.5033 50.0036 47.2754 50.0036 47.0039V22.2101C50.0036 21.5569 49.474 21.0273 48.8208 21.0273ZM43.6576 35.155C43.6576 35.4902 43.2519 35.6584 43.0146 35.4211L31.5835 23.99C31.3462 23.7527 31.5145 23.347 31.8496 23.347H43.1918C43.449 23.347 43.6576 23.5557 43.6576 23.8129V35.155Z",
    fill: "url(#paint1_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6551 17.3461C49.441 17.132 49.1455 17 48.8185 17H19.9984C19.1453 17 18.7185 18.0301 19.3212 18.6328L20.8398 20.1514H46.8498L49.6551 17.3461Z",
    fill: "url(#paint2_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8516 46.161L48.3701 47.6796C48.9727 48.2822 50.0029 47.8554 50.0029 47.0024V18.1823C50.0029 17.8553 49.8709 17.5598 49.6568 17.3457L46.8516 20.151V46.161Z",
    fill: "url(#paint3_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1644 17.8752V19.2756C22.1644 19.4656 22.0104 19.6195 21.8205 19.6195C21.6305 19.6195 21.4766 19.4655 21.4766 19.2756V17.8752C21.4766 17.6852 21.6305 17.5312 21.8205 17.5312C22.0104 17.5312 22.1644 17.6852 22.1644 17.8752Z",
    fill: "url(#paint4_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0941 17.8752V18.5911C24.0941 18.7811 23.9401 18.935 23.7502 18.935C23.5602 18.935 23.4062 18.7811 23.4062 18.5911V17.8752C23.4062 17.6852 23.5602 17.5312 23.7502 17.5312C23.9401 17.5312 24.0941 17.6852 24.0941 17.8752Z",
    fill: "url(#paint5_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0159 17.8752V18.5911C26.0159 18.7811 25.862 18.935 25.672 18.935C25.4821 18.935 25.3281 18.7811 25.3281 18.5911V17.8752C25.3281 17.6852 25.4821 17.5312 25.672 17.5312C25.862 17.5312 26.0159 17.6852 26.0159 17.8752Z",
    fill: "url(#paint6_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9456 17.8752V19.2756C27.9456 19.4656 27.7916 19.6195 27.6017 19.6195C27.4118 19.6195 27.2578 19.4655 27.2578 19.2756V17.8752C27.2578 17.6852 27.4118 17.5312 27.6017 17.5312C27.7916 17.5312 27.9456 17.6852 27.9456 17.8752Z",
    fill: "url(#paint7_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8753 17.8752V18.5911C29.8753 18.7811 29.7213 18.935 29.5314 18.935C29.3415 18.935 29.1875 18.7811 29.1875 18.5911V17.8752C29.1875 17.6852 29.3415 17.5312 29.5314 17.5312C29.7213 17.5312 29.8753 17.6852 29.8753 17.8752Z",
    fill: "url(#paint8_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7972 17.8752V18.5911C31.7972 18.7811 31.6432 18.935 31.4533 18.935C31.2634 18.935 31.1094 18.7811 31.1094 18.5911V17.8752C31.1094 17.6852 31.2634 17.5312 31.4533 17.5312C31.6432 17.5312 31.7972 17.6852 31.7972 17.8752Z",
    fill: "url(#paint9_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7268 17.8752V19.2756C33.7268 19.4656 33.5728 19.6195 33.3829 19.6195C33.193 19.6195 33.0391 19.4655 33.0391 19.2756V17.8752C33.0391 17.6852 33.193 17.5312 33.3829 17.5312C33.5728 17.5312 33.7268 17.6852 33.7268 17.8752Z",
    fill: "url(#paint10_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6566 17.8752V18.5911C35.6566 18.7811 35.5026 18.935 35.3126 18.935C35.1227 18.935 34.9688 18.7811 34.9688 18.5911V17.8752C34.9688 17.6852 35.1227 17.5312 35.3126 17.5312C35.5026 17.5312 35.6566 17.6852 35.6566 17.8752Z",
    fill: "url(#paint11_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5784 17.8752V18.5911C37.5784 18.7811 37.4244 18.935 37.2345 18.935C37.0446 18.935 36.8906 18.7811 36.8906 18.5911V17.8752C36.8906 17.6852 37.0446 17.5312 37.2345 17.5312C37.4244 17.5312 37.5784 17.6852 37.5784 17.8752Z",
    fill: "url(#paint12_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5081 17.8752V19.2756C39.5081 19.4656 39.3541 19.6195 39.1642 19.6195C38.9743 19.6195 38.8203 19.4655 38.8203 19.2756V17.8752C38.8203 17.6852 38.9743 17.5312 39.1642 17.5312C39.3541 17.5312 39.5081 17.6852 39.5081 17.8752Z",
    fill: "url(#paint13_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.43 17.8752V18.5911C41.43 18.7811 41.276 18.935 41.0861 18.935C40.8962 18.935 40.7422 18.7811 40.7422 18.5911V17.8752C40.7422 17.6852 40.8962 17.5312 41.0861 17.5312C41.2761 17.5312 41.43 17.6852 41.43 17.8752Z",
    fill: "url(#paint14_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3596 17.8752V18.5911C43.3596 18.7811 43.2056 18.935 43.0157 18.935C42.8258 18.935 42.6719 18.7811 42.6719 18.5911V17.8752C42.6719 17.6852 42.8258 17.5312 43.0157 17.5312C43.2056 17.5312 43.3596 17.6852 43.3596 17.8752Z",
    fill: "url(#paint15_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2894 17.8752V19.2756C45.2894 19.4656 45.1354 19.6195 44.9455 19.6195C44.7555 19.6195 44.6016 19.4655 44.6016 19.2756V17.8752C44.6016 17.6852 44.7555 17.5312 44.9455 17.5312C45.1354 17.5312 45.2894 17.6852 45.2894 17.8752Z",
    fill: "url(#paint16_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1271 21.4378H47.7267C47.5367 21.4378 47.3828 21.2838 47.3828 21.0939C47.3828 20.904 47.5368 20.75 47.7267 20.75H49.1271C49.317 20.75 49.471 20.904 49.471 21.0939C49.471 21.2839 49.317 21.4378 49.1271 21.4378Z",
    fill: "url(#paint17_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1223 23.3655H48.4063C48.2164 23.3655 48.0625 23.2116 48.0625 23.0216C48.0625 22.8317 48.2165 22.6777 48.4063 22.6777H49.1223C49.3122 22.6777 49.4662 22.8317 49.4662 23.0216C49.4662 23.2116 49.3122 23.3655 49.1223 23.3655Z",
    fill: "url(#paint18_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1223 25.2913H48.4063C48.2164 25.2913 48.0625 25.1373 48.0625 24.9474C48.0625 24.7574 48.2165 24.6035 48.4063 24.6035H49.1223C49.3122 24.6035 49.4662 24.7575 49.4662 24.9474C49.4662 25.1373 49.3122 25.2913 49.1223 25.2913Z",
    fill: "url(#paint19_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1271 27.2171H47.7267C47.5367 27.2171 47.3828 27.0631 47.3828 26.8732C47.3828 26.6833 47.5368 26.5293 47.7267 26.5293H49.1271C49.317 26.5293 49.471 26.6833 49.471 26.8732C49.471 27.0632 49.317 27.2171 49.1271 27.2171Z",
    fill: "url(#paint20_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1223 29.1448H48.4063C48.2164 29.1448 48.0625 28.9908 48.0625 28.8009C48.0625 28.611 48.2165 28.457 48.4063 28.457H49.1223C49.3122 28.457 49.4662 28.611 49.4662 28.8009C49.4662 28.9908 49.3122 29.1448 49.1223 29.1448Z",
    fill: "url(#paint21_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1223 31.0706H48.4063C48.2164 31.0706 48.0625 30.9167 48.0625 30.7267C48.0625 30.5368 48.2165 30.3828 48.4063 30.3828H49.1223C49.3122 30.3828 49.4662 30.5368 49.4662 30.7267C49.4662 30.9167 49.3122 31.0706 49.1223 31.0706Z",
    fill: "url(#paint22_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1271 32.9984H47.7267C47.5367 32.9984 47.3828 32.8444 47.3828 32.6545C47.3828 32.4645 47.5368 32.3105 47.7267 32.3105H49.1271C49.317 32.3105 49.471 32.4645 49.471 32.6545C49.471 32.8444 49.317 32.9984 49.1271 32.9984Z",
    fill: "url(#paint23_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1223 34.9241H48.4063C48.2164 34.9241 48.0625 34.7701 48.0625 34.5802C48.0625 34.3902 48.2165 34.2363 48.4063 34.2363H49.1223C49.3122 34.2363 49.4662 34.3903 49.4662 34.5802C49.4662 34.7701 49.3122 34.9241 49.1223 34.9241Z",
    fill: "url(#paint24_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1223 36.8519H48.4063C48.2164 36.8519 48.0625 36.6979 48.0625 36.508C48.0625 36.318 48.2165 36.1641 48.4063 36.1641H49.1223C49.3122 36.1641 49.4662 36.318 49.4662 36.508C49.4662 36.698 49.3122 36.8519 49.1223 36.8519Z",
    fill: "url(#paint25_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1271 38.7776H47.7267C47.5367 38.7776 47.3828 38.6236 47.3828 38.4337C47.3828 38.2438 47.5368 38.0898 47.7267 38.0898H49.1271C49.317 38.0898 49.471 38.2438 49.471 38.4337C49.471 38.6236 49.317 38.7776 49.1271 38.7776Z",
    fill: "url(#paint26_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1223 40.7054H48.4063C48.2164 40.7054 48.0625 40.5514 48.0625 40.3615C48.0625 40.1716 48.2165 40.0176 48.4063 40.0176H49.1223C49.3122 40.0176 49.4662 40.1716 49.4662 40.3615C49.4662 40.5514 49.3122 40.7054 49.1223 40.7054Z",
    fill: "url(#paint27_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1223 42.6311H48.4063C48.2164 42.6311 48.0625 42.4771 48.0625 42.2873C48.0625 42.0973 48.2165 41.9434 48.4063 41.9434H49.1223C49.3122 41.9434 49.4662 42.0973 49.4662 42.2873C49.4662 42.4772 49.3122 42.6311 49.1223 42.6311Z",
    fill: "url(#paint28_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1271 44.5588H47.7267C47.5367 44.5588 47.3828 44.4049 47.3828 44.2149C47.3828 44.025 47.5368 43.8711 47.7267 43.8711H49.1271C49.317 43.8711 49.471 44.0251 49.471 44.2149C49.471 44.4049 49.317 44.5588 49.1271 44.5588Z",
    fill: "url(#paint29_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4107 48.4535H43.4695C43.0364 48.4535 42.6852 48.1023 42.6852 47.6692C42.6852 47.2361 43.0364 46.8849 43.4695 46.8849H44.4107C44.8438 46.8849 45.195 47.2361 45.195 47.6692C45.195 48.1023 44.8439 48.4535 44.4107 48.4535ZM40.3323 48.4535H39.3911C38.958 48.4535 38.6068 48.1023 38.6068 47.6692C38.6068 47.2361 38.958 46.8849 39.3911 46.8849H40.3323C40.7654 46.8849 41.1166 47.2361 41.1166 47.6692C41.1166 48.1023 40.7655 48.4535 40.3323 48.4535ZM36.2539 48.4535H35.3127C34.8795 48.4535 34.5284 48.1023 34.5284 47.6692C34.5284 47.2361 34.8795 46.8849 35.3127 46.8849H36.2539C36.687 46.8849 37.0382 47.2361 37.0382 47.6692C37.0382 48.1023 36.687 48.4535 36.2539 48.4535ZM32.1754 48.4535H31.2342C30.8011 48.4535 30.4499 48.1023 30.4499 47.6692C30.4499 47.2361 30.8011 46.8849 31.2342 46.8849H32.1754C32.6086 46.8849 32.9597 47.2361 32.9597 47.6692C32.9597 48.1023 32.6086 48.4535 32.1754 48.4535ZM28.097 48.4535H27.1558C26.7227 48.4535 26.3715 48.1023 26.3715 47.6692C26.3715 47.2361 26.7227 46.8849 27.1558 46.8849H28.097C28.5301 46.8849 28.8813 47.2361 28.8813 47.6692C28.8813 48.1023 28.5302 48.4535 28.097 48.4535ZM24.0186 48.4535H23.0774C22.6443 48.4535 22.2931 48.1023 22.2931 47.6692C22.2931 47.2361 22.6443 46.8849 23.0774 46.8849H24.0186C24.4517 46.8849 24.8029 47.2361 24.8029 47.6692C24.8029 48.1023 24.4518 48.4535 24.0186 48.4535ZM19.9401 48.4535H19.3312C18.8981 48.4535 18.5469 48.1023 18.5469 47.6692V47.337C18.5469 46.9038 18.8981 46.5526 19.3312 46.5526C19.5963 46.5526 19.8307 46.6842 19.9727 46.8856C20.3908 46.9026 20.7244 47.247 20.7244 47.6692C20.7244 48.1024 20.3733 48.4535 19.9401 48.4535ZM19.3313 44.984C18.8981 44.984 18.5469 44.6328 18.5469 44.1997V43.2585C18.5469 42.8254 18.8981 42.4742 19.3313 42.4742C19.7644 42.4742 20.1156 42.8254 20.1156 43.2585V44.1997C20.1156 44.6328 19.7644 44.984 19.3313 44.984ZM19.3313 40.9056C18.8981 40.9056 18.5469 40.5544 18.5469 40.1213V39.1801C18.5469 38.747 18.8981 38.3958 19.3313 38.3958C19.7644 38.3958 20.1156 38.747 20.1156 39.1801V40.1213C20.1156 40.5544 19.7644 40.9056 19.3313 40.9056ZM19.3313 36.8271C18.8981 36.8271 18.5469 36.476 18.5469 36.0428V35.1016C18.5469 34.6685 18.8981 34.3173 19.3313 34.3173C19.7644 34.3173 20.1156 34.6685 20.1156 35.1016V36.0428C20.1156 36.476 19.7644 36.8271 19.3313 36.8271ZM19.3313 32.7487C18.8981 32.7487 18.5469 32.3975 18.5469 31.9644V31.0232C18.5469 30.5901 18.8981 30.2389 19.3313 30.2389C19.7644 30.2389 20.1156 30.5901 20.1156 31.0232V31.9644C20.1156 32.3975 19.7644 32.7487 19.3313 32.7487ZM19.3313 28.6703C18.8981 28.6703 18.5469 28.3191 18.5469 27.886V26.9448C18.5469 26.5117 18.8981 26.1605 19.3313 26.1605C19.7644 26.1605 20.1156 26.5117 20.1156 26.9448V27.886C20.1156 28.3191 19.7644 28.6703 19.3313 28.6703ZM19.3313 24.5918C18.8981 24.5918 18.5469 24.2407 18.5469 23.8075V22.8663C18.5469 22.4332 18.8981 22.082 19.3313 22.082C19.7644 22.082 20.1156 22.4332 20.1156 22.8663V23.8075C20.1156 24.2407 19.7644 24.5918 19.3313 24.5918Z",
    fill: "#7E8595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6682 49.0005C20.5895 49.0005 21.3364 48.2536 21.3364 47.3323C21.3364 46.4109 20.5895 45.6641 19.6682 45.6641C18.7469 45.6641 18 46.4109 18 47.3323C18 48.2536 18.7469 49.0005 19.6682 49.0005Z",
    fill: "url(#paint30_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6657 48.7239C20.4346 48.7239 21.0579 48.1006 21.0579 47.3317C21.0579 46.5628 20.4346 45.9395 19.6657 45.9395C18.8968 45.9395 18.2734 46.5628 18.2734 47.3317C18.2734 48.1006 18.8968 48.7239 19.6657 48.7239Z",
    fill: "url(#paint31_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4182 45.8398C20.5307 46.0644 20.5941 46.3178 20.5941 46.5861C20.5941 47.5074 19.8472 48.2543 18.9259 48.2543C18.6576 48.2543 18.4043 48.1908 18.1797 48.0783C18.4535 48.625 19.0188 49.0004 19.6719 49.0004C20.5932 49.0004 21.3401 48.2535 21.3401 47.3322C21.3402 46.6791 20.9648 46.1138 20.4182 45.8398Z",
    fill: "url(#paint32_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6682 25.0337C20.5895 25.0337 21.3364 24.2868 21.3364 23.3655C21.3364 22.4441 20.5895 21.6973 19.6682 21.6973C18.7469 21.6973 18 22.4441 18 23.3655C18 24.2868 18.7469 25.0337 19.6682 25.0337Z",
    fill: "url(#paint33_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6657 24.7572C20.4346 24.7572 21.0579 24.1338 21.0579 23.3649C21.0579 22.596 20.4346 21.9727 19.6657 21.9727C18.8968 21.9727 18.2734 22.596 18.2734 23.3649C18.2734 24.1338 18.8968 24.7572 19.6657 24.7572Z",
    fill: "url(#paint34_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4182 21.873C20.5307 22.0976 20.5941 22.351 20.5941 22.6193C20.5941 23.5406 19.8472 24.2875 18.9259 24.2875C18.6576 24.2875 18.4043 24.224 18.1797 24.1115C18.4536 24.6582 19.0189 25.0335 19.672 25.0335C20.5933 25.0335 21.3402 24.2866 21.3402 23.3653C21.3402 22.7123 20.9648 22.147 20.4182 21.873Z",
    fill: "url(#paint35_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6526 49.0005C44.5739 49.0005 45.3208 48.2536 45.3208 47.3323C45.3208 46.4109 44.5739 45.6641 43.6526 45.6641C42.7313 45.6641 41.9844 46.4109 41.9844 47.3323C41.9844 48.2536 42.7313 49.0005 43.6526 49.0005Z",
    fill: "url(#paint36_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6501 48.7239C44.419 48.7239 45.0423 48.1006 45.0423 47.3317C45.0423 46.5628 44.419 45.9395 43.6501 45.9395C42.8811 45.9395 42.2578 46.5628 42.2578 47.3317C42.2578 48.1006 42.8811 48.7239 43.6501 48.7239Z",
    fill: "url(#paint37_linear_170_7098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4025 45.8398C44.5151 46.0644 44.5785 46.3178 44.5785 46.5861C44.5785 47.5074 43.8316 48.2543 42.9103 48.2543C42.642 48.2543 42.3886 48.1908 42.1641 48.0783C42.4379 48.625 43.0033 49.0003 43.6563 49.0003C44.5777 49.0003 45.3245 48.2534 45.3245 47.3321C45.3245 46.6791 44.9492 46.1138 44.4025 45.8398Z",
    fill: "url(#paint38_linear_170_7098)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_170_7098",
    x1: 32.856,
    y1: 10.1302,
    x2: 46.3994,
    y2: 74.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_170_7098",
    x1: 38.9737,
    y1: 27.9364,
    x2: 32.8173,
    y2: 10.1512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_170_7098",
    x1: 34.3471,
    y1: 16.8989,
    x2: 34.3471,
    y2: 26.7188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_170_7098",
    x1: 50.1268,
    y1: 32.6537,
    x2: 44.5176,
    y2: 32.6537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_170_7098",
    x1: 21.7404,
    y1: 18.5754,
    x2: 22.448,
    y2: 18.5754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_170_7098",
    x1: 23.6701,
    y1: 18.2332,
    x2: 24.3777,
    y2: 18.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_170_7098",
    x1: 25.592,
    y1: 18.2332,
    x2: 26.2996,
    y2: 18.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_170_7098",
    x1: 27.5216,
    y1: 18.5754,
    x2: 28.2292,
    y2: 18.5754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_170_7098",
    x1: 29.4514,
    y1: 18.2332,
    x2: 30.159,
    y2: 18.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_170_7098",
    x1: 31.3732,
    y1: 18.2332,
    x2: 32.0808,
    y2: 18.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_170_7098",
    x1: 33.3028,
    y1: 18.5754,
    x2: 34.0104,
    y2: 18.5754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_170_7098",
    x1: 35.2327,
    y1: 18.2332,
    x2: 35.9402,
    y2: 18.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_170_7098",
    x1: 37.1544,
    y1: 18.2332,
    x2: 37.862,
    y2: 18.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_170_7098",
    x1: 39.0842,
    y1: 18.5754,
    x2: 39.7918,
    y2: 18.5754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_170_7098",
    x1: 41.0061,
    y1: 18.2332,
    x2: 41.7137,
    y2: 18.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_170_7098",
    x1: 42.9357,
    y1: 18.2332,
    x2: 43.6432,
    y2: 18.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_170_7098",
    x1: 44.8655,
    y1: 18.5754,
    x2: 45.573,
    y2: 18.5754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_170_7098",
    x1: 48.4269,
    y1: 21.0139,
    x2: 48.4269,
    y2: 21.7215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_170_7098",
    x1: 48.7643,
    y1: 22.9416,
    x2: 48.7643,
    y2: 23.6492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_170_7098",
    x1: 48.7643,
    y1: 24.8674,
    x2: 48.7643,
    y2: 25.5749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_170_7098",
    x1: 48.4269,
    y1: 26.7932,
    x2: 48.4269,
    y2: 27.5008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_170_7098",
    x1: 48.7643,
    y1: 28.7208,
    x2: 48.7643,
    y2: 29.4284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_170_7098",
    x1: 48.7643,
    y1: 30.6467,
    x2: 48.7643,
    y2: 31.3543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_170_7098",
    x1: 48.4269,
    y1: 32.5744,
    x2: 48.4269,
    y2: 33.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_170_7098",
    x1: 48.7643,
    y1: 34.5001,
    x2: 48.7643,
    y2: 35.2077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_170_7098",
    x1: 48.7643,
    y1: 36.428,
    x2: 48.7643,
    y2: 37.1355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_170_7098",
    x1: 48.4269,
    y1: 38.3536,
    x2: 48.4269,
    y2: 39.0612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_170_7098",
    x1: 48.7643,
    y1: 40.2814,
    x2: 48.7643,
    y2: 40.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_170_7098",
    x1: 48.7643,
    y1: 42.2072,
    x2: 48.7643,
    y2: 42.9148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_170_7098",
    x1: 48.4269,
    y1: 44.1349,
    x2: 48.4269,
    y2: 44.8424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_170_7098",
    x1: 19.0441,
    y1: 46.7081,
    x2: 21.2047,
    y2: 48.8687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_170_7098",
    x1: 19.8658,
    y1: 47.6154,
    x2: 18.8366,
    y2: 46.1562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_170_7098",
    x1: 19.7299,
    y1: 47.9715,
    x2: 22.0229,
    y2: 43.7068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_170_7098",
    x1: 19.0441,
    y1: 22.7413,
    x2: 21.2047,
    y2: 24.9019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_170_7098",
    x1: 19.8658,
    y1: 23.6486,
    x2: 18.8366,
    y2: 22.1894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_170_7098",
    x1: 19.7299,
    y1: 24.0047,
    x2: 22.0229,
    y2: 19.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_170_7098",
    x1: 43.0284,
    y1: 46.7081,
    x2: 45.189,
    y2: 48.8687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_170_7098",
    x1: 43.8502,
    y1: 47.6154,
    x2: 42.8209,
    y2: 46.1562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_170_7098",
    x1: 43.7143,
    y1: 47.9715,
    x2: 46.0073,
    y2: 43.7068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_7098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(18 17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt2);
export default __webpack_public_path__ + "static/media/ct2.0474fbd5855df72663d7432eeb9c2f36.svg";
export { ForwardRef as ReactComponent };